import { createSlice } from '@reduxjs/toolkit';

const socketSlice = createSlice({
  name: 'sockets',
  initialState: {
    socketId: null,
    socket: null,
  },
  reducers: {
    createSocket(state, action) {
      state.socketId = action.payload.socketId;
      state.socket = action.payload.socket;
    },
    clearSocket(state) {
      state.socketId = null;
    },
  },
});

export default socketSlice.reducer;
export const { createSocket, clearSocket } = socketSlice.actions;
